import styled from 'styled-components'
import { Spinner } from 'src/components/common/Spinner'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16, Noto_body2_b14, Noto_heading3_b20 } from 'src/styles/fonts/NotoSansKrFonts'
import useLockBodyScroll from 'src/hooks/useLockBodyScroll.hook'
import { Container } from 'src/components/common/Container'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { layoutMaxSize } from 'src/styles/mixin'
import React from 'react'
import { createPortal } from 'react-dom'

const textLogo = `${process.env.PUBLIC_URL}/images/text_logo.svg`

const DefaultLoading = () => {
  useLockBodyScroll(true)
  return createPortal(
    <LoadingWrap $gap="20px">
      <Spinner $color="var(--white)" />
    </LoadingWrap>,
    document.body,
  )
}

const OCRLoading = () => {
  useLockBodyScroll(true)
  return (
    <LoadingWrap $gap="20px">
      <Spinner $color="var(--white)" />
      <Typography $fontStyle={Noto_body2_b14} $color="var(--white)">
        이미지에서 텍스트를 추출 중입니다
      </Typography>
    </LoadingWrap>
  )
}

const SearchKeywordMapLoading = () => {
  useLockBodyScroll(true)
  return (
    <LoadingWrap $gap="20px">
      <Spinner $color="var(--white)" />
      <Typography $fontStyle={Noto_body2_b14} $color="var(--white)">
        검색된 가맹점 위치를 불러오는 중입니다.
      </Typography>
    </LoadingWrap>
  )
}

const PaymentCouponInProgressLoading = ({ onClickFn }: { onClickFn: () => void }) => {
  useLockBodyScroll(true)
  return (
    <PaymentStyle.LoadingContainer $option="flex_column">
      <PaymentStyle.InProgressContainer $option="flex_column_space_between">
        <PaymentStyle.InProgressHeader $option="flex_column">
          <PaymentStyle.HeaderLogoImage src={textLogo} alt="logo" />
        </PaymentStyle.InProgressHeader>
        <PaymentStyle.InProgressContents $option="flex_column">
          <Container $option="flex_column" $row_gap="20px">
            <Typography $fontStyle={Noto_heading3_b20}>결제를 시작합니다.</Typography>
            <Typography $fontStyle={Noto_body1_r16}>
              결제 완료 후에도 해당 화면이 보인다면 아래 버튼을 눌러주세요.
            </Typography>
          </Container>
        </PaymentStyle.InProgressContents>
        <PaymentStyle.InProgressButtonWrap $option="flex_column">
          <Button option={ButtonOption3('active')} onClickFn={onClickFn}>
            결제결과 확인하기
          </Button>
        </PaymentStyle.InProgressButtonWrap>
      </PaymentStyle.InProgressContainer>
    </PaymentStyle.LoadingContainer>
  )
}

const LoadingWrap = styled.div<{ $gap?: string }>`
  width: 100%;
  min-height: calc(var(--vh, 1dvh) * 100);
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.$gap};
`

const PaymentStyle = {
  LoadingContainer: styled(Container)`
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
  `,
  InProgressContainer: styled(Container)`
    ${layoutMaxSize};
    margin: 0 auto;
    height: 100%;
    min-height: calc(var(--vh, 1vh) * 100);
    background-color: var(--black-2);
    overflow: auto;
  `,
  InProgressHeader: styled(Container)`
    justify-content: center;
    height: 50px;
    background-color: var(--white);
    border-bottom: 1px solid var(--black-6);
  `,
  HeaderLogoImage: styled.img`
    height: 38px;
  `,
  InProgressContents: styled(Container)`
    max-width: 320px;
    flex: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;
    gap: 70px;
    padding: 0 20px;
    word-break: keep-all;
  `,
  InProgressButtonWrap: styled(Container)`
    ${layoutMaxSize};
    padding: 0 30px 40px;
  `,
}

export const Loading = {
  Default: DefaultLoading,
  OCR: OCRLoading,
  SearchKeyword: SearchKeywordMapLoading,
  PaymentCouponInProgress: PaymentCouponInProgressLoading,
}
